import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "bop_admin_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve image URLs: external stay as-is, relative /api/images/... get backend prefix
export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  return `${BACKEND_URL}${url}`;
};

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
  isLoggedIn: () => !!localStorage.getItem(TOKEN_KEY),
};

export const suppliesApi = {
  list: (params = {}) => api.get("/supplies", { params }).then((r) => r.data),
  meta: () => api.get("/supplies/meta").then((r) => r.data),
  create: (data) => api.post("/supplies", data).then((r) => r.data),
  update: (id, data) => api.put(`/supplies/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/supplies/${id}`).then((r) => r.data),
};

export const adminApi = {
  login: (password) => api.post("/admin/login", { password }).then((r) => r.data),
  verify: () => api.get("/admin/verify").then((r) => r.data),
};

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
